export const ACTION_UPDATE_STATE = "ACTION_UPDATE_STATE"
export const ACTION_CREATE_RECORD = "ACTION_CREATE_RECORD"
export const ACTION_UPDATE_RECORD = "ACTION_UPDATE_RECORD"
